// Filter Blogs
var topicFilter = document.getElementById('topic-filter'),
	practiceFilter = document.getElementById('practice-filter');

[].slice.call(document.querySelectorAll('.filter-container select')).forEach(function(filter) {
	filter.addEventListener('change', function() {
		if(this.id == 'category-filter' && window.location.href != this.value) {
			window.location.href = this.value;
		} else if(this == topicFilter || this == practiceFilter) {
			var data = {
					'topic' : topicFilter.value,
					'practice' : practiceFilter.value
				};

			axios.post('/blog-filter', data).then(function(r) {
				if(r.data.html) {
					document.querySelector('section.blog .filters-wrapper + *').remove();
					document.querySelector('section.blog .filters-wrapper').insertAdjacentHTML('afterend', r.data.html);
				}
			});
		}
	});
});